import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import Excel from "exceljs";
import { IAuditAndTrail } from "src/Types/module/auditAndTrail/auditAndTrail";
import FileSaver from "file-saver";
import moment from "moment";

const AuditAndTrailExcelGenerator = ({ getDownloadData }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const workbook = new Excel.Workbook();

  const downloadAuditExcelReport = async () => {
    setLoading(true);
    try {
      const data = await getDownloadData();
      const sheet = workbook.addWorksheet("audit_trail_report");
      sheet
        .addRow(["Admin Name", "Details", "Date"])
        .eachCell((cell) => (cell.font = { bold: true }));
      data?.data?.map(
        ({
          user_admin_name,
          audit_trail_details,
          audit_trail_created_at,
        }: IAuditAndTrail) =>
          sheet.addRow([
            user_admin_name,
            audit_trail_details,
            moment(audit_trail_created_at).format("DD/MM/YYYY, h:mm:ss a"),
          ])
      );
      const genarateExcelFile = await workbook.xlsx.writeBuffer();
      FileSaver.saveAs(new Blob([genarateExcelFile]), "audit_trail_report.xlsx");
    } catch (error) {
      console.error("Error generating Excel report:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoadingButton
      loading={loading}
      loadingPosition={loading ? "end" : undefined}
      onClick={downloadAuditExcelReport}
      variant="outlined"
      size="large"
    >
      {loading ? "Loading..." : "Download Excel"}
    </LoadingButton>
  );
};

export default AuditAndTrailExcelGenerator;
